module.exports = __webpack_public_path__ + "static/media/addIcon.5ed610c4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Images/addIcon.svg
 ** module id = 354
 ** module chunks = 0
 **/